import {Component, OnInit, Inject, DestroyRef, inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {RegexConstants} from '@emm/core/util/regex.constants';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';
import {TagService} from '@emm/core/services/tag.service';
import {LocationSetTypeService} from '@emm/core/services/location-set-type.service';

@Component({
    selector: 'emm-add-location-set-type-dialog',
    styleUrls: ['./add-location-set-type-dialog.component.scss'],
    templateUrl: './add-location-set-type-dialog.component.html'
})
export class AddLocationSetTypeDialogComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    form: FormGroup;
    isReadOnly = this.authFacade.isReadOnly$;
    name: string;
    spaceValidatorPattern = RegexConstants.STARTING_SPACE_VALIDATIOR_PATTERN;

    constructor(
        private authFacade: AuthFacadeService,
        public dialogRef: MatDialogRef<AddLocationSetTypeDialogComponent>,
        public tagService: TagService,
        public locationSetTypeService: LocationSetTypeService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.buildForm();
    }



    ngOnInit(): void {
        this.dialogRef.updatePosition({ top: '100px' });
    }



    onNoClick(): void {
        this.dialogRef.close();
    }



    buildForm(): void {
        this.form = new FormGroup({
            description: new FormControl(''),
            locked: new FormControl(''),
            name: new FormControl(''),
            tag: new FormControl(''),
            weight: new FormControl('')
        });
    }



    findTagExists(): void {
        if (this.form.controls['tag'].valid) {
            this.tagService
                .getLocationSetTypeTags(this.form.get('tag').value)
                .pipe(
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe((res) => {
                    if (res === true) {
                        this.form.controls['tag'].setErrors({ tagExists: true });
                    }
                });
        }
    }



    OnSubmit(): void {
        if (this.form.valid) {
            const locationSetType = {
                description: this.form.controls['description'].value,
                locked: this.form.controls['locked'].value,
                name: this.form.controls['name'].value,
                tag: this.form.controls['tag'].value,
                weight: this.form.controls['weight'].value
            };
            this.locationSetTypeService
                .createLocationSetType(locationSetType)
                .pipe(
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe(() => {
                    this.dialogRef.close('submit');
                });
        }
    }



}
